import {ParameterStore} from '../../../../Core/mobx/ParameterStore/ParameterStore';
import {ProsperFormValues} from './validation';

export const defaultValues = (parameterStore: ParameterStore): ProsperFormValues => {
    const {approval, quote, prequal} = parameterStore;
    return {
        emailAddress: approval.emailAddress.value,
        prosperSmoker: prequal.tobacco.value || false,
        prosperAmplifySolves: quote.prosperAmplifySolves.value,
        prosperSpecify: quote.prosperSpecify.value,
        prosperAmount: quote.prosperAmount.value,
        prosperIllustrationRequest: quote.prosperIllustrationRequest.value,
        prosperRiskClass: quote.prosperRiskClass.value,
        prosperTableRating: quote.prosperTableRating.value,
        prosperFlatExtra: quote.prosperFlatExtra.value,
        prosperFaceAmountType: quote.prosperFaceAmountType.value,
        prosperFaceAmount: quote.prosperFaceAmount.value,
        prosperDeathBenefitOption: quote.prosperDeathBenefitOption.value,
        prosperPremiumMode: quote.prosperPremiumMode.value,
        prosperPremium: quote.prosperPremium.value,
        prosperPremiumType: quote.prosperPremiumType.value,
        prosperLumpSum: quote.prosperLumpSum.value,
        prosperPremiumEndYear: quote.prosperPremiumEndYear.value,
        prosperPremiumAge: quote.prosperPremiumAge.value,
        prosperIndexName: quote.prosperIndexName.value,
        prosperIndexedAllocationPercent: quote.prosperIndexedAllocationPercent.value,
        prosperIndexedAccountRateOfReturn: quote.prosperIndexedAccountRateOfReturn.value,
        prosperDistributionAmount: quote.prosperDistributionAmount.value,
        prosperDistributionType: quote.prosperDistributionType.value,
        prosperDistributionStartAge: quote.prosperDistributionStartAge.value,
        prosperDistributionEndAge: quote.prosperDistributionEndAge.value,
        prosperAllowMEC: quote.prosperAllowMEC.value,
        prosperDefinitionOfLifeInsurance: quote.prosperDefinitionOfLifeInsurance.value,
        prosperSolveGoal: quote.prosperSolveGoal.value,
        prosperSolveAge: quote.prosperSolveAge.value,
        prosperDeathBenefitChangeAge: quote.prosperDeathBenefitChangeAge.value,
        prosperFlatExtraDuration: quote.prosperFlatExtraDuration.value,
        prosperDistributionSolveType: quote.prosperDistributionSolveType.value,
    };
};
